module.exports = __webpack_public_path__ + "assets/img/3p.07ee92b4.png";